module.exports = __webpack_public_path__ + "fb5a07b123fd43caa0c157f574eaf621.gif";